import { Component } from '@angular/core';

import { ModalComponent } from './../modal/modal.component';
import { EventRunner } from './../core/app.core.events';
import { WebsocketService} from "./../services/websocket.service";
import { NeverumeComponent } from "./../neverume.component";     
import { Directionality } from '@angular/cdk/bidi';
import { ArrayAssociative } from "./../core/array.core.data";
import { MatDialog } from '@angular/material/dialog';
import { PostnickComponent } from './postnick.component';
import { ModalService } from './../services/modal.service';

@Component({
  selector: 'postauth',
  templateUrl: './postauth.component.html',
  styleUrl: './postauth.component.scss',
  providers: [ ],
  standalone: !true
})
export class PostauthComponent {
	
	currentDirection: any;
	neverume: any;
	nick: string = '';
	//md:  MatDialog;

	constructor(private websoketService: WebsocketService,	private directionality: Directionality) {
		this.currentDirection = this.directionality.value;
		//this.md = md;
	}
	
	  
	onSubmit() {
		let message: ArrayAssociative = {
				event: 'registation',
				route: '/signverify/registration',
				nick: this.nick
			}
		this.websoketService.sendws(message);
		
	//	this.neverume.sendMsg(message);
	}
}